import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldStrom } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeEnergiedatenStromProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export class DateneingabeEnergiedatenStrom extends React.Component<DateneingabeEnergiedatenStromProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.filterOptions = this.filterOptions.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    filterOptions?(options: Array<any>, key: string, data: any): Array<any> {
        const standort_gebaeude: Array<any> = this.props.data[IDs.ENT_GEBAEUDE] || [];
        const { standort_tid } = data;
        const gebaeude: Array<number> = (standort_tid
            ? standort_gebaeude
                .filter((item: any) => (item.standort_tid_orig || null) === standort_tid)
            : standort_gebaeude)
                .map((item: any) => item.tid);

        switch (key) {
            case 'gebaeude_tid':
                return options
                    ? options.filter((item: any) => item.tid && gebaeude.indexOf(item.tid) > -1)
                    : options;
            default:
                return options;
        }
    }

    onFormChange(WFormData: any): void {
        onFormChangeUniversal(IDs.ENT_ENERGIEDATEN_STROM, WFormData, this);
    }

    preFilter(data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        const konfiguration: Array<any> = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const showElektrofahrzeuge: boolean = !!konfiguration
            .some((param: any) => param.daten_elektrofahrzeuge_orig === 1);
        const showGebaeude: boolean = !!konfiguration
            .some((param: any) => param.daten_standorte_gebaeude_orig === 1);
        const customFormConfig: any = {
            ...(showElektrofahrzeuge ? {} : { seperate_abrechnung_emobil_strom: { hidden: true } }),
            ...(showGebaeude ? {} : { gebaeude_tid: { hidden: true } })
        };
        const hiddenColumns: Array<string> = [
            ...(showGebaeude ? [] : ['gebaeude_tid']),
            ...(showElektrofahrzeuge ? [] : ['seperate_abrechnung_emobil_strom'])
        ];

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_ENERGIEDATEN_STROM}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    externalHeaderElements={[this.renderAuswertungButton()]}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={'Strom erfassen'}
                    onFormChange={this.onFormChange}
                    preFilterFunction={this.preFilter}
                    valueFieldSelectDefaultOptions={{ monat: 'Ganzes Jahr' }}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_STROM)}
                    filterOptions={this.filterOptions}
                    validateField={this.validateField}
                    hiddenColumns={hiddenColumns}
                    customFormConfig={customFormConfig}
                />
            </div>
        );
    }

    renderAuswertungButton(): JSX.Element {
        return (
            <WActionButton
                label='Auswertung'
                insideText='Auswertung'
                tooltip='Zum Datenauswertungsbereich springen'
                key='auswertung'
                action='view'
                onAction={() => this.props.onRoutingChange({ path: RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM })}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldStrom(key, value, data, onValueChange);
    }
}
